import { BaseComponent } from '../base-component.js';

export class AgCardContent extends BaseComponent {


  static observedAttributes = ['fontsize'];

  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-card-content ${this.getAttribute('fontsize') || ""}"><slot></slot></div>`;
  }
}

customElements.define('ag-card-content', AgCardContent);
